<template lang="pug">
  .clusterize
    #scrollArea.clusterize-scroll
      table.tablex.fixed-header-table#contentArea.clusterize-content(style="width: auto;").mb-5
        thead.text-center
          tr
            th(style="width: 80px;")
              div {{ $t('ui.time') }}
            th(style="width: 450px;")
              div {{ $t('ui.event') }}
            th
              div {{ $tc('ui.odds', 1) }}
            th
              div {{ $t('ui.even') }}
            th
              div 0-1
            th
              div 2-3
            th
              div 4-6
            th
              div 7+
        tbody(v-for="(item, index) in cacheList")
          tr
            td(style="width: 80px;")
              div {{ item.mt == 'live'? item.rs : item.ed }}
              div {{ item.mt == 'live'? item.rt : item.et }}
            td(style="width: 450px;")
              div.text-info {{ item.th }}
              div.text-warning {{ item.ta }}
              div.text-danger {{ item.ln }}
            td(style="width: 40px;").text-center
              div(:class="{'up': item.fodd_blink }") {{ item.fodd }}
            td(style="width: 40px;").text-center
              div(:class="{'up': item.feven_blink }") {{ item.feven }}
            td(style="width: 40px;").text-center
              div(:class="{'up': item.ftg01_blink }") {{ item.ftg01 }}
            td(style="width: 40px;").text-center
              div(:class="{'up': item.ftg23_blink }") {{ item.ftg23 }}
            td(style="width: 40px;").text-center
              div(:class="{'up': item.ftg46_blink }") {{ item.ftg46 }}
            td(style="width: 40px;").text-center
              div(:class="{'up': item.ftg7o_blink }") {{ item.ftg7o }}
</template>
<script>
export default {
  components: {},
  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    cacheList: {
      type: Array,
      default: ""
    },
    betType: {
      type: String,
      default: ""
    },
    sportType: {
      type: String,
      default: ""
    },
    marketType: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    cleanup() {
      this.$forceUpdate();
    }
  }
};
</script>